/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Dataswift Logo</title>
    <path d="M46.773 7.79003C41.0429 2.76699 33.5965 0 24.1373 0H0C0 3.25693 3.162 5.89793 6.366 5.89793H23.3929C30.2128 5.89793 38.308 8.15514 42.9845 12.2555C47.6411 16.3383 50.2046 21.9271 50.2046 27.9965C50.1979 29.4885 50.0711 30.9775 49.8254 32.4491C49.8186 32.4966 49.7944 32.5398 49.7576 32.5705C49.7208 32.6012 49.6739 32.6171 49.626 32.6152C49.5781 32.6133 49.5326 32.5937 49.4983 32.5603C49.464 32.5268 49.4433 32.4818 49.4403 32.4339C48.9736 27.4179 46.3833 22.7192 42.5703 19.3386C38.0641 15.3432 31.2524 13.1432 24.4991 13.1432H7.46394C7.46394 16.4001 10.6248 19.04 13.8288 19.04H24.4979C35.1262 19.04 43.7499 25.716 43.7499 34.5675C43.7499 42.718 36.0491 49.079 27.6097 49.7323C22.8877 50.0962 7.46044 50.1032 7.46044 50.1032C7.46044 53.3602 10.9795 56 14.1835 56H25.1513C33.3608 56 41.0371 53.2342 46.7672 48.2111C52.7178 42.9921 56 35.8157 56 28.0035C56 20.1913 52.7272 13.0079 46.773 7.79003Z" />
  </svg>
);
